import { render, staticRenderFns } from "./PaquetesEliminar.vue?vue&type=template&id=5a5cbdb5&scoped=true"
import script from "./PaquetesEliminar.vue?vue&type=script&lang=js"
export * from "./PaquetesEliminar.vue?vue&type=script&lang=js"
import style0 from "./PaquetesEliminar.vue?vue&type=style&index=0&id=5a5cbdb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5cbdb5",
  null
  
)

export default component.exports